import BaseApiClient from '../BaseApiClient';

const API_VERSION = { Version: '2025-11-14' };

export type AudiencePresetApiItem = {
  id: string;
  name: string;
  kind: 'preset' | string;
  status: 'published' | 'draft' | string;
  size: number;
  owner_name: string;
  updated_at: string | null;
  company_type_names: string[];
  companies?: Array<{
    id: number;
    name: string | null;
    uuid: string | null;
  }>;
};

export class ApiAudiencePresets extends BaseApiClient {
  async list(): Promise<AudiencePresetApiItem[]> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/audience-presets', { headers: API_VERSION })
        .then((res) => resolve(res.data.data ?? []))
        .catch((err) => reject(err));
    });
  }

  async get(id: string): Promise<AudiencePresetApiItem> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/audience-presets/${id}`, { headers: API_VERSION })
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err));
    });
  }
}
